// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t2WZ","label":"styles_label__226GL"};